module.exports = __webpack_public_path__ + "fonts/50e6537.otf";